import React, { useState } from "react";
import DashboardStatsDetail from "../components/DashboardStats/DashboardStatsDetail";

const DashboardPage = () => {
  const [detailView, setDetailView] = useState(true);
  if (detailView) {
    return <DashboardStatsDetail />;
  }
  return <></>;
};

export default DashboardPage;
